import { ROUTES } from '../route-configuration';

export interface NavDestination {
  id: string;
  label: string;
  path: string;
  icon?: string;
  badge?: string | number;
  children?: NavDestination[];
  requiredPermission?: string;
}

// Main navigation items
export const MAIN_NAVIGATION: NavDestination[] = [
  {
    id: 'dashboard',
    label: 'Dashboard',
    path: ROUTES.DASHBOARD,
    icon: 'dashboard',
  },
  {
    id: 'clients',
    label: 'Clients',
    path: ROUTES.CLIENTS,
    icon: 'users',
  },
  {
    id: 'proposals',
    label: 'Proposals',
    path: ROUTES.PROPOSALS_INDEX,
    icon: 'document',
  },
];
